"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEventListener_1 = __importDefault(require("hooks/useEventListener"));
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const useCheckedContentChange_1 = __importDefault(require("./hooks/useCheckedContentChange"));
const mapStateToProps = (stores, props) => ({
    modules: props.isExtra
        ? stores.ContentStore.modulesExtraList || []
        : stores.ContentStore.modulesList || []
});
const FloatingBulkActionMenu = ({ onClose, checkedContent, modules }) => {
    const sendCheckedContentEvent = (0, useCheckedContentChange_1.default)();
    (0, react_1.useEffect)(() => {
        sendCheckedContentEvent(checkedContent, modules);
    }, [sendCheckedContentEvent, checkedContent, modules]);
    (0, useEventListener_1.default)('app-content-admin:bulkactionsmenu:create-dripping', stores_1.BulkDrippingStore.startNewAction);
    (0, useEventListener_1.default)('app-content-admin:bulkactionsmenu:delete-dripping', stores_1.BulkDrippingStore.startDeleteAction);
    (0, useEventListener_1.default)('app-content-admin:bulkactionsmenu:closed', (event) => {
        onClose(event.detail);
    });
    return null;
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(FloatingBulkActionMenu);
